<template>
  <sp-button
    tag="a"
    variant="outlined"
    size="small"
    no-wrap
    block
    :title="slot.visit_type_categories_description"
    :href="slot.booking_url"
  >
    <sp-icon v-if="visitTypeIcon" slot="prepend" :name="visitTypeIcon" size="s"></sp-icon>
    {{ formatStartTime(slot.start_time) }}
  </sp-button>
</template>

<script setup>
import moment from "moment";
import { computed } from "vue";

const props = defineProps({
  entry: {
    type: Object,
    required: true,
  },
});
const slot = computed(() => props.entry);

const visitTypeIcon = computed(() => {
  if (slot.value.visit_type_categories.includes("video")) {
    return "video-visit-filled";
  }

  return undefined;
});

function formatStartTime(startTime) {
  return moment.parseZone(startTime).format("h:mm A");
}
</script>

<style scoped lang="scss">
sp-button {
  --sp-comp-button-small-padding: 0;
  --sp-comp-button-prepend-icon-fill: var(--sp-sys-color-primary, currentColor);
}
</style>
